<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app><v-toolbar-title class="ml-0 pl-3"> Snap Drive </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                  Welcome to the Snap Drive Charge Center Dashboard
                </div>
              </div>
            </v-card-title>
            <v-form ref="loginForm" v-model="loginForm" class="pa-4 pt-6">
              <v-text-field outline v-model="model.username" :rules="[rules.email]" label="Email address" type="email"
                @keyup.enter="login"></v-text-field>
              <v-text-field outline v-model="model.password" :rules="[rules.required]" label="Password"
                style="min-height: 96px" type="password" dense @keyup.enter="login"></v-text-field>

              <v-layout row wrap>
                <v-flex>
                  

                  <v-subheader style="padding-top: 15px"><router-link to="/reset-password-email">Reset
                      password</router-link></v-subheader>
                </v-flex>
              </v-layout>
              <v-btn @click="login" :loading="loading" block color="secondary" dark>Login</v-btn>
            </v-form>
          </v-card>
          
        </v-layout>
      </v-container>

    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { getFirstAllowedPage } from "@/utils/permissionHelpers";

export default {
  title: "Login",
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: "",
      password: "",
      code: "",
      remember_me: "",
    },
    page: 0,
    socket: null,
    dialog: false,
    email: undefined,
    loginForm: false,
    isLoading: false,
    password: undefined,
    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length == len || `Invalid character length, required ${len}`,
      password: (v) =>
        !!(v || "").match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë])[A-Za-z\d!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë]{8,15}$/) || "Password must be 8-15 characters, and it must contain at least one uppercase letter, one lowercase letter, one number and one special character.",
      required: (v) => !!v || "Password is required",
    },
  }),
  
  methods: {
    async login() {
      if (this.loading)
        return;
      if (!this.$refs.loginForm.validate())
        return;
      this.error = false;
      this.loading = true;
      this.axios
        .post(this.api.ACTIONS.LOGIN, { ...this.model, provider: "users" })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.data);
          this.$store.commit("USER_NAME", data.data.username);
          // console.log(this.$store.state.USER_NAME);
          let next = { name: "Home" };
          next = getFirstAllowedPage();
          window.getApp.$emit("APP_LOGIN_SUCCESS");
          this.$router.push(next);
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", "Check your info", "red");
          }
        })
        .then(() => (this.loading = false));
    },
   
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
